module.exports = __webpack_public_path__ + "static/media/cowbell.af87805c.svg";